/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowADownIcon20Regular = forwardRef('ArrowADownIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M9.25 16.468V2.5a.75.75 0 0 1 1.5 0v13.968l.046-.043 5.236-5.237a.75.75 0 1 1 1.06 1.061l-5.236 5.237a2.625 2.625 0 0 1-3.712 0l-5.237-5.237a.75.75 0 1 1 1.06-1.06l5.237 5.236c.015.015.03.03.046.043Z" })));
});
